import React, { useState, FC } from 'react';
import { AnimatePresence } from 'motion/react'

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { headerConfig } from 'utils/headerConfig';
import { MobileNavProps, Styled } from './';
import { useI18n } from 'contexts/i18n';
import { useMenus } from 'reactQuery/queries/useMenus';
import Link from 'next/link';

export const MobileNavMenu: FC<MobileNavProps> = ({
  tabs,
  isMenuOpen,
  onMobileMenuItemClick,
}) => {
  const [showStoreSubNavigation, setStoreSubNavigation] = useState(true);
  const i18n = useI18n();
  const menuAnimation = {
    enter: {
      x: 0,
    },
    initial: {
      x: -1000,
    },
  };

  const { data: menus } = useMenus();
  const mainMenuItems = menus?.children ?? [];

  return (
    <AnimatePresence>
      <Styled.MobileNavigationItemListContainer
        variants={menuAnimation}
        initial="initial"
        animate={'enter'}
        transition={{ type: 'tween' }}
      >
        <Styled.MobileNavigationItemList>
          {tabs.map(tab => {
            return tab.label === headerConfig.currentlyActiveTab &&
              isMenuOpen ? (
              <React.Fragment key={tab.label}>
                <Styled.GlobalAppName
                  isActive={true}
                  onClick={() => setStoreSubNavigation(!showStoreSubNavigation)}
                >
                  {i18n[tab.label]}
                  {showStoreSubNavigation ? (
                    <MdKeyboardArrowUp />
                  ) : (
                    <MdKeyboardArrowDown />
                  )}
                </Styled.GlobalAppName>
                <Styled.SubNavigationList>
                  {mainMenuItems?.map(mainMenu => (
                    <Styled.SubNavigationListItem
                      key={mainMenu.id}
                      onClick={() => onMobileMenuItemClick(isMenuOpen)}
                    >
                      <Link href={mainMenu.link} passHref legacyBehavior>
                        <Styled.LinkText>{mainMenu.name}</Styled.LinkText>
                      </Link>
                    </Styled.SubNavigationListItem>
                  ))}
                </Styled.SubNavigationList>
              </React.Fragment>
            ) : (
              <Styled.AppName
                key={tab.label}
                href={tab.link}
                isActive={tab.label === headerConfig.currentlyActiveTab}
              >
                {i18n[tab.label]}
              </Styled.AppName>
            );
          })}
        </Styled.MobileNavigationItemList>
      </Styled.MobileNavigationItemListContainer>
    </AnimatePresence>
  );
};
